import React from 'react';
import { connect } from 'react-redux';
import * as resourceTypes from '../../../constants/resourceTypes';
import { saveTagsOnResource } from '../../../actions';
import { debounce, isEqual } from 'lodash';
import UIUtils from '../../../lib/UIUtils';
import { SelectInput, SelectOption, baseSelectStyles } from '../rselect/ReactSelectUtils';
import SortedSelect from '../rselect/SortedSelect';

class TagsEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: props.tags ? UIUtils.tagsToOps(props.tags) : [],
      value: props.data ? UIUtils.tagsToOps(props.data.tags) : [],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevProps.data && this.props.data && !isEqual(prevProps.data.tags, this.props.data.tags)) ||
      !isEqual(this.props.tags, prevProps.tags)
    ) {
      this.setState({
        options: UIUtils.tagsToOps(this.props.tags),
        value: UIUtils.tagsToOps(this.props.data.tags),
      });
    }
  }

  saveOnServer = debounce((value) => {
    this.props.saveTagsOnResource(
      this.props.data.id,
      this.props.resourceType,
      UIUtils.opsToTags(value),
    );
  }, 800);
  handleOnChange = (value) => {
    this.saveOnServer(value);
    this.setState({ value });
  };

  render() {
    let { options, value } = this.state;
    const { readOnly } = this.props;
    const selectTagsStyles = {
      ...baseSelectStyles,
      menu: (base) => ({
        ...base,
        marginTop: 0,
        fontSize: 12,
        fontWeight: 300,
        boxShadow: 'inset 0 0 0 1px hsla(0,0%,0%,0.1), 0 4px 11px hsla(0,0%,0%,0.1)',
        zIndex: 99999,
      }),
      menuList: (base) => ({ ...base, paddingLeft: 1, paddingRight: 1 }),
    };
    return (
      <div>
        <SortedSelect
          isCreatable={true}
          isMulti={true}
          options={options}
          isDisabled={readOnly}
          components={{ Input: SelectInput, Option: SelectOption }}
          onChange={this.handleOnChange}
          value={value}
          promptTextCreator={(label) => 'Create tag ' + label}
          placeholder="Start typing to select or create tags"
          isClearable={false}
          backspaceRemovesValue={false}
          styles={selectTagsStyles}
        />
      </div>
    );
  }
}

TagsEditor.defaultProps = {
  readOnly: false,
};

const mapStateToProps = (state, ownProps) => {
  const { entities, tags } = state;
  const { id, resourceType } = ownProps;
  let data;
  switch (resourceType) {
    case resourceTypes.RESOURCE_TYPE_SOURCE:
      data = entities.sources[id];
      break;
    case resourceTypes.RESOURCE_TYPE_DATA_SET:
      data = entities.dataSets[id];
      break;
    case resourceTypes.RESOURCE_TYPE_SINK:
      data = entities.sinks[id];
      break;
    case resourceTypes.RESOURCE_TYPE_DATA_MAP:
      data = entities.dataMaps[id];
      break;
    case resourceTypes.RESOURCE_TYPE_ATTR_TRANSFORM:
    case resourceTypes.RESOURCE_TYPE_RECORD_TRANSFORM:
      data = entities.transforms[id];
      break;

    case resourceTypes.RESOURCE_TYPE_SCHEMA_SPECS:
      data = entities.schemaSpecs[id];
      break;

    case resourceTypes.RESOURCE_TYPE_PROJECTS:
      data = entities.projects[id];
      break;

    default:
      data = null;
  }
  return {
    data,
    tags: tags.tags,
  };
};

export default connect(mapStateToProps, {
  saveTagsOnResource,
})(TagsEditor);
